module.exports = __webpack_public_path__ + "static/media/hands-over-face.d3d90d46.gif";